import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { convertKeyValueToObject } from '../../../utils/helpers';
import UrlEditor from '../../Panes/RequestUrl/UrlEditor';
import RequestTabGroup from '../../Tab-Groups/RequestTabGroup';

const keyPairInitState = [
  {
    id: uuidv4(),
    keyItem: '',
    valueItem: '',
  },
];

export default function Request({ setResponse, setLoading, setHistory, selectedRequest }) {
  const [url, setUrl] = useState('https://jsonplaceholder.typicode.com/todos/1');
  const [reqMethod, setReqMethod] = useState('GET');
  const [queryParams, setQueryParams] = useState(keyPairInitState);
  const [headers, setHeaders] = useState(keyPairInitState);
  const [body, setBody] = useState('{\n\t\n}');

  useEffect(() => {
    if (selectedRequest) {
      setUrl(selectedRequest.url || '');
      setReqMethod(selectedRequest.method || 'GET');
      setBody(selectedRequest.body ? JSON.stringify(selectedRequest.body, null, 2) : '{\n\t\n}');
      setQueryParams(
        selectedRequest.params && selectedRequest.params.length > 0
          ? selectedRequest.params.map((param) => ({
              id: uuidv4(),
              keyItem: param.key,
              valueItem: param.value,
            }))
          : keyPairInitState
      );
      setHeaders(
        selectedRequest.headers && selectedRequest.headers.length > 0
          ? selectedRequest.headers.map((header) => ({
              id: uuidv4(),
              keyItem: header.key,
              valueItem: header.value,
            }))
          : keyPairInitState
      );
    }
  }, [selectedRequest]);

  const handleOnInputSend = async (e) => {
    setLoading(true);
    e.preventDefault();
    let data;
    try {
      data = body && body.trim() !== '{\n\t\n}' ? JSON.parse(body) : null;
    } catch (e) {
      alert('Something is wrong with the JSON data.');
      setLoading(false);
      return;
    }

    try {
      const response = await axios({
        url: url,
        method: reqMethod,
        params: convertKeyValueToObject(queryParams),
        headers: convertKeyValueToObject(headers),
        data,
      });

      setResponse(response);
      setHistory((prev) => [
        ...prev,
        {
          method: reqMethod,
          url,
          status: response.status,
          timestamp: new Date().toISOString(),
        },
      ]);
    } catch (e) {
      console.log(e);
      setResponse(e);
      setHistory((prev) => [
        ...prev,
        {
          method: reqMethod,
          url,
          status: e.response?.status || 'Error',
          timestamp: new Date().toISOString(),
        },
      ]);
    }
    setLoading(false);
  };

  return (
    <>
      <UrlEditor
        url={url}
        setUrl={setUrl}
        reqMethod={reqMethod}
        setReqMethod={setReqMethod}
        onInputSend={handleOnInputSend}
      />
      <RequestTabGroup
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        headers={headers}
        setHeaders={setHeaders}
        body={body}  // Pass the dynamic body state
        setBody={setBody}
      />
    </>
  );
}